<template>
    <ul class="flex flex-wrap gap-1 justify-center lg:justify-start">
        <ClientOnly>
            <li v-for="[tag, tagName] in tags" :key="tag">
                <input type="radio" name="tag" :value="tag" :id="`tag-${tag}`" class="absolute opacity-0 w-0 h-0"
                    :checked="(tag === checked || !checked && tag === 'all')" />
                <label :for="`tag-${tag}`" class="block p-2 px-4 border-2 border-primary rounded-lg cursor-pointer">
                    {{ tagName }}
                </label>
            </li>
        </ClientOnly>
    </ul>
</template>

<script setup>
const props = defineProps({
    checked: String || undefined
})

const tags = new Map([
    ['all', 'All'],
    ['news', 'News'],
    ['podcast', 'Podcast'],
    ['video', 'Video'],
    ['tutorial', 'Tutorial'],
    ['engineering', 'Engineering'],
    ['case-study', 'Case Study'],
    ['community', 'Community'],
    ['newsletter', 'Newsletter']
])

</script>

<style scoped lang="postcss">
li input[type=radio]:checked+label {
    background-color: var(--color-primary-500);
    color: white;
    font-weight: bold;
}

li label:hover,
li label:focus {
    background-color: var(--color-primary-100);
    color: rgb(51 65 85);
}
</style>
